import createIcon from '../../createIcon';

/**
 * @component @name FormatListNumbered
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDE3SDQuNVYxNy41SDMuNVYxOC41SDQuNVYxOUgyLjVWMjBINS41VjE2SDIuNVYxN1pNMy41IDhINC41VjRIMi41VjVIMy41VjhaTTIuNSAxMUg0LjNMMi41IDEzLjFWMTRINS41VjEzSDMuN0w1LjUgMTAuOVYxMEgyLjVWMTFaTTcuNSA1VjdIMjEuNVY1SDcuNVpNNy41IDE5SDIxLjVWMTdINy41VjE5Wk03LjUgMTNIMjEuNVYxMUg3LjVWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatListNumbered = createIcon('FormatListNumbered', [
  [
    'path',
    {
      d: 'M2.5 17H4.5V17.5H3.5V18.5H4.5V19H2.5V20H5.5V16H2.5V17ZM3.5 8H4.5V4H2.5V5H3.5V8ZM2.5 11H4.3L2.5 13.1V14H5.5V13H3.7L5.5 10.9V10H2.5V11ZM7.5 5V7H21.5V5H7.5ZM7.5 19H21.5V17H7.5V19ZM7.5 13H21.5V11H7.5V13Z',
      key: 'o3ic5a',
    },
  ],
]);

export default FormatListNumbered;
